import { useDataProvider } from 'context/DataProviderContext';
import { useEffect, useState } from 'react';
import { totalCountEvent } from 'services/generalServices';
import { getCaseMatter } from 'services/lead/leadServices';

export function useCaseMatter(excludeFromLoading = false) {
  const { caseMatterList, setCaseMatterList } = useDataProvider();
  const [isCaseMatterLoading, setIsCaseMatterLoading] = useState(false);

  const loadCaseMatter = () => {
    setIsCaseMatterLoading(true);
    totalCountEvent('case-matter')
      .then((response) => {
        getCaseMatter({ pageLimit: response.data, excludeFromLoading: excludeFromLoading })
          .then((res) => setCaseMatterList(res.data?.['case-matter'] || []))
          .catch((error) => console.error(error))
          .finally(() => setIsCaseMatterLoading(false));
      })
      .catch((err) => {
        setIsCaseMatterLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    caseMatterList?.length === 0 && loadCaseMatter();
  }, []);

  return { caseMatterList, isCaseMatterLoading, loadCaseMatter };
}
